/* eslint-disable max-len */
import React from 'react';

type GiftOutlineProps = {
  width?: number;
  height?: number;
  color?: string;
};

export function GiftOutline({ width = 48, height = 48, color = '#000000', ...props }: GiftOutlineProps): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 48 48' fill='none' {...props}>
      <title>Gift Outline</title>
      <path
        d='M42.0982 22.6078H5.90137V42.0984C5.90137 42.8369 6.19472 43.5451 6.71689 44.0673C7.23906 44.5894 7.94728 44.8828 8.68574 44.8828H39.3139C40.0523 44.8828 40.7605 44.5894 41.2827 44.0673C41.8049 43.5451 42.0982 42.8369 42.0982 42.0984V22.6078Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M42.0984 14.2547H5.90156C5.1631 14.2547 4.45488 14.5481 3.93271 15.0702C3.41054 15.5924 3.11719 16.3006 3.11719 17.0391V21.2156C3.11719 21.5849 3.26386 21.939 3.52495 22.2001C3.78604 22.4611 4.14014 22.6078 4.50938 22.6078H43.4906C43.8599 22.6078 44.214 22.4611 44.4751 22.2001C44.7361 21.939 44.8828 21.5849 44.8828 21.2156V17.0391C44.8828 16.3006 44.5895 15.5924 44.0673 15.0702C43.5451 14.5481 42.8369 14.2547 42.0984 14.2547Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.6078 14.2547C16.4562 14.2547 10.0781 9.2688 10.0781 3.11719'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.0781 3.11719C16.2297 3.11719 22.6078 8.10307 22.6078 14.2547'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.3926 14.2547C31.5442 14.2547 37.9223 9.2688 37.9223 3.11719'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.9223 3.11719C31.7707 3.11719 25.3926 8.10307 25.3926 14.2547'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.8232 14.2547H28.1764V44.8828H19.8232V14.2547Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
